"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  requiredError: {
    id: 'components.FieldValidator.requiredError',
    defaultMessage: 'Campo obrigatório'
  },
  minLengthError: {
    id: 'components.FieldValidator.minLengthError',
    defaultMessage: 'Preencha com no mínimo {minValue} caracteres'
  },
  maxLengthError: {
    id: 'components.FieldValidator.maxLengthError',
    defaultMessage: 'Preencha com no máximo {maxValue} caracteres'
  }
});